/* global chrome */
import React, {useState, useContext, useEffect} from 'react';
import {Link, withRouter, useParams} from 'react-router-dom';
import authApi from '../services/api/auth';
import {GlobalContext} from "../context/GlobalState";
import "../styles/auth.scss";
import ReactGA from 'react-ga';
import Plaudy from 'plaudy';

const AutoLogin = ({history}) => {
  const {logIn, userData} = useContext(GlobalContext);

  const {token} = useParams();
  console.log('TOKEN:', token);

  if (userData && userData.accountLevel) {
    history.push('/home');
  }

  const handleLogin = async e => {
    try {
      const data = {
        token
      };

      const response = await authApi.duplicateLogin(data);
      const userData = response.data;
      ReactGA.event({
        category: 'User',
        action: 'Auto Logged In',
      });
      Plaudy.track('autologin', {
        userId: userData.id,
        email: userData.email,
      });

      logIn({userData});

      const extensionId = "hemjflepggljigpcaneoeldgipbpcbmg";

      if (chrome) {
        chrome.runtime.sendMessage(extensionId, {type: 'autoLogin', token: userData.loginToken}, () => {
          window.close();
        });
      }

      history.push('/home');
    } catch (error) {
      if (typeof error.response.data === 'string') {
        console.log('ERROR:', error.response.data);
      } else {
        console.log('ERROR:', error);
      }
    }
  };

  useEffect(() => {
    handleLogin();
  }, []);

  return (
    <div className="container">
      <p>We're logging you into app.getrocketnote.com. 🚀 Please wait a moment...</p>
    </div>
  );
};

export default withRouter(AutoLogin);
